import store from "../store";
export default class PatientExamMultiviewContext {
  constructor(exams, images) {
    this.exams = [...exams];
    this.filteredExams = [...exams];
    this.currentExams = [];
    this.selectedExams = [];

    this.images = [...images];
    this.filteredImages = [...images];
    this.currentImages = [];
    this.selectedImages = [];

    this.currentEye = "";

    this.deviceList = [];
    this.deviceFilter = [];

    this.dateList = [];
    this.dateFilter = [];

    this.isCollapsed = store.getters.multiviewCollapseUserPref != null ? store.getters.multiviewCollapseUserPref == 1 : (store.getters.multiviewCollapseByDefault != null ? store.getters.multiviewCollapseByDefault : false);
  }

  refreshImages() {
    return store.dispatch("refreshMultiview");
  }

  constructFilters() {
    this.deviceList = this.exams.map(e => e.exDevice)
      // get unique devices
      .filter((d, i, self) => self.indexOf(d) === i)
      .sort();
    this.deviceFilter = this.deviceList.slice();

    this.dateList = this.exams.slice()
      .sort((a, b) => a.moment.diff(b.moment))
      .map(exam => exam.dateDisplay).reverse();
    this.dateFilter = this.dateList.slice();
  }

  reconstructFilters() {
    let newDeviceList = this.exams.map(e => e.exDevice)
      // get unique devices
      .filter((d, i, self) => self.indexOf(d) === i)
      .sort();
    if (newDeviceList.join(",") !== this.deviceList.join(","))
      this.deviceFilter = newDeviceList.slice();

    let newDateList = this.exams.slice()
      .sort((a, b) => a.moment.diff(b.moment))
      .map(exam => exam.dateDisplay).reverse();
    if (newDateList.join(",") !== this.dateList.join(","))
      this.dateFilter = this.dateList.slice();
  }

  selectEye(eye) {
    if (eye === this.currentEye) this.currentEye = "";
    else this.currentEye = eye;
    this.updateFilteredImages();
  }

  selectDevices(devices) {
    this.deviceFilter = devices;
    this.updateFilteredImages();
  }

  selectAllDevices() {
    if (this.deviceList.length === this.deviceFilter.length)
      this.deviceFilter = [];
    else
      this.deviceFilter = this.deviceList.slice();
      this.updateFilteredImages();
    }

  selectDates(dates) {
    this.dateFilter = dates;
    this.updateFilteredImages();
  }

  selectAllDates() {
    if (this.dateList.length === this.dateFilter.length)
      this.dateFilter = [];
    else
      this.dateFilter = this.dateList.slice();
    this.updateFilteredImages();
  }

  selectExams(exams) {
    let dropped = this.selectedExams.filter(e => !exams.includes(e));
    let added = exams.filter(e => !this.selectedExams.includes(e));
    this.selectedExams = exams && exams.slice() || [];

    this.images.forEach(i => {
      if (dropped.some(e => e.exSrNo === i.exSrNo)) {
        this.selectedImages = this.selectedImages.filter(si => si !== i);
      } else if (added.some(e => e.exSrNo === i.exSrNo)) {
        if (!this.selectedImages.includes(i)) this.selectedImages.push(i);
      }
    })
  }

  selectAllExams() {
    if (this.exams.length === this.selectedExams.length) this.selectedExams = [];
    else this.selectedExams = this.exams.slice();

    if (this.selectedExams.length) this.selectedImages = this.images.slice();
    else this.selectedImages = [];
  }

  fixSelectedExams() {
    let addExams = [];
    let removeExams = [];
    this.exams.forEach(e => {
      let images = this.images.filter(i => i.exSrNo === e.exSrNo);
      let selectedImages = this.selectedImages.filter(i => i.exSrNo === e.exSrNo);
      let shouldBeSelected = images.length !== 0 && (images.length === selectedImages.length);
      let isSelected = this.selectedExams.some(se => se === e);
      if (shouldBeSelected && !isSelected) addExams.push(e);
      else if (!shouldBeSelected && isSelected) removeExams.push(e);
    });

    this.selectedExams = this.selectedExams
      .filter(e => !removeExams.includes(e))
      .concat(addExams);
  }

  selectImage(image) {
    if (!this.images.includes(image)) return;

    if (this.selectedImages.includes(image)) {
      this.selectedImages = this.selectedImages
        .filter(i => i !== image);
      this.selectedExams = this.selectedExams
        .filter(e => e.exSrNo !== image.exSrNo);
    }
    else {
      this.selectedImages.push(image);
      let exam = this.exams.find(e => e.exSrNo === image.exSrNo);
      if (exam && !this.selectedExams.includes(exam))
      {
        let imagesInExam = this.images.filter(i => i.exSrNo === image.exSrNo);
        let selectedInExam = this.selectedImages.filter(i => i.exSrNo === image.exSrNo);
        if (imagesInExam.length === selectedInExam.length)
          this.selectedExams.push(exam);
      }
    }
  }

  refreshExams(exams) {
    this.exams = exams;
    this.selectedExams = exams.filter(e => this.selectedExams.some(se => e.exSrNo === se.exSrNo));
    this.reconstructFilters();
  }

  removeImages(imgSrNos) {
    this.selectedImages = this.selectedImages.filter(i => !imgSrNos.includes(i.flSrNo));
    this.images = this.images.filter(i => !imgSrNos.includes(i.flSrNo));
    this.updateFilteredImages();
  }

  resetImages({ exams, images }) {
    this.exams = [...exams];
    this.images = [...images];
    this.updateFilteredImages();
    this.updateCurrentImages();
  }

  updateFilteredImages() {
    let eye = this.currentEye;
    this.filteredImages = this.images
      .filter(i => !eye || i.imgEye === eye || (i.imgEye === "U" && eye === "OU"))
      .filter(i => this.deviceFilter.includes(i.exDevice))
      .filter(i => this.dateFilter.includes(i.exDateDisplay));
    this.updateSelectedImages();
    this.updateFilteredExams();
  }

  updateSelectedImages() {
    this.selectedImages = this.selectedImages.filter(i => this.images.includes(i));
    this.fixSelectedExams();
  }

  updateFilteredExams() {
    this.filteredExams = this.exams.filter(e => this.filteredImages.some(i => e.exSrNo == i.exSrNo));
  }

  setCurrentExams(bounds) {
    this.currentExams = this.filteredExams.slice(bounds.start, bounds.end);
    this.updateCurrentImages();
  }

  updateCurrentImages() {
    this.currentImages = this.filteredImages.filter(i => this.currentExams.some(e => i.exSrNo == e.exSrNo));
  }

  toggleCollapse() {
    this.isCollapsed = !this.isCollapsed;
  }
}

